import EventsPage from '../../components/EventsPage';

export default function TrusteeEvents() {
  return <EventsPage />;
}
